import { render, staticRenderFns } from "./PasienMultiWarningIndicator.vue?vue&type=template&id=cbbb79f4&scoped=true&"
import script from "./PasienMultiWarningIndicator.vue?vue&type=script&lang=ts&"
export * from "./PasienMultiWarningIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbb79f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VIcon,VProgressCircular,VTooltip})
